import { numberFormat as defaultNumberFormat } from "src/lib/format";

// Note: These columns must be in the same order as what's being returned from the backend
// TODO: Make this not a thing ^
export const getAovColumns = (numberFormat = defaultNumberFormat) => [
  {
    title: "# of Orders",
    field: "orders",
    format: numberFormat.whole,
    viewByDefault: true,
  },
  {
    title: "∑ Orders",
    field: "cumulativeOrders",
    format: numberFormat.whole,
  },
  {
    title: "Collected Shipping",
    field: "shipping",
    format: numberFormat.currency,
    viewByDefault: true,
  },
  {
    title: "∑ Collected Shipping",
    field: "cumulativeShipping",
    format: numberFormat.currency,
  },
  {
    title: "Collection Rate",
    field: "collectionRate",
    format: numberFormat.percentTimes100,
    viewByDefault: true,
    color: "var(--chart-1)",
  },
  {
    title: "UPT",
    field: "upt",
    format: numberFormat.normal,
    viewByDefault: true,
    color: "var(--chart-2)",
  },
  {
    title: "Distribution %",
    field: "distribution",
    format: numberFormat.percentTimes100,
    viewByDefault: true,
    color: "var(--chart-3)",
  },
  {
    title: "∑ Distribution %",
    field: "cumulativeDistribution",
    format: numberFormat.percentTimes100,
  },
  {
    title: "Profit",
    field: "profit",
    format: numberFormat.currency,
  },
  {
    title: "Profit/Order",
    field: "profitPerOrder",
    format: numberFormat.currency,
    viewByDefault: true,
  },
  {
    title: "Revenue",
    field: "revenue",
    format: numberFormat.currency,
  },
  {
    title: "Revenue/Order",
    field: "revenuePerOrder",
    format: numberFormat.currency,
  },
  {
    title: "Repeat Customers",
    field: "repeatCustomers",
    format: numberFormat.whole,
  },
  {
    title: "Repeat Customer %",
    field: "repeatCustomerRate",
    format: numberFormat.percentTimes100,
    // TODO: add a color gradient
  },
];

export default getAovColumns();
